<template>
  <page>
    <div>
      <v-card>
        <form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-text>
                    <div slot="header">
                        <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                    </div>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12 md6 lg6>
                              <v-autocomplete :items="tranTypeList" v-model="form.tranType" :label="label.tranType" item-text="label" item-value="value" data-vv-name="form.tranType" :data-vv-as="label.tranType" :error-messages="errors.collect('form.tranType')" v-validate="'required'"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 md6 lg6>
                            </v-flex>
                            <v-flex xs12 md6 lg6>
                              <v-text-field v-model="form.docNoFrom" :label="label.docNoFrom" data-vv-name="form.docNoFrom" :data-vv-as="label.docNoFrom" :error-messages="errors.collect('form.docNoFrom')" v-validate="'required|numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 lg6>
                              <v-text-field v-model="form.docNoTo" :label="label.docNoTo" data-vv-name="form.docNoTo" :data-vv-as="label.docNoTo" :error-messages="errors.collect('form.docNoTo')" v-validate="doValidateDocNoTo"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 lg6>
                              <v-autocomplete :items="branchOption" v-model="form.branch" :label="label.branch" item-text="label" item-value="value" data-vv-name="form.branch" :data-vv-as="label.branch" :error-messages="errors.collect('form.branch')" v-validate="'required'" @change="doDisplaysBranch($event)"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 md6 lg6>
                              <v-autocomplete v-if="form.branch === 'S'" multiple :items="branchList" v-model="form.sBranch" :label="label.sBranch" item-text="label" item-value="value" data-vv-name="form.sBranch" :data-vv-as="label.sBranch" :error-messages="errors.collect('form.sBranch')" v-validate="'required'"></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card>
                  <v-flex xs12>
                    <v-checkbox
                      :label="label.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="label.pbPrtParam"
                    />
                  </v-flex>
      <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{label.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { tranTypeList, branchOption } from './index'
import clone from 'clone'

export default {
  data() {
    return {
      form: {
        tranType: '',
        docNoFrom: '',
        docNoTo: '',
        branch: 'A',
        sBranch: '',
        format: undefined,
        pbPrtParam: true
      },
      label: {
        tranType: 'Transaction Type',
        docNoFrom: 'From Document No.*',
        docNoTo: 'To Document No.*',
        branch: 'Branch(es)',
        sBranch: 'Selected Branch(es)*',
        format: 'Export Format',
        export: 'Export to',
        pbPrtParam: 'Print Runtime Parameters'
      },
      menu: {},
      supportedFormat: [],
      loading: false,
      tranTypeList: [],
      branchOption: [],
      branchList: []
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.riReports.init !== 1) {
          await Promise.all([this.$store.dispatch('riReportsInit')])
        }
        const apiURI = this.$store.state.reports.riReports.menu.riAppBordereaux
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getBranchList()
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let dataObj = clone(this.form)
          if (dataObj.sBranch) {
            dataObj.sBranch = this.form.sBranch.join()
          }
          await this.$http.post(apiURI, dataObj)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getBranchList() {
      const apiURI = this.menu.getBranchList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.branchList = []
          if (data) {
            for (let i in data) {
              this.branchList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doDisplaysBranch(data) {
      if (data === 'A') {
        this.form.sBranch = ''
      }
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    doValidateDocNoTo() {
      if (this.form.docNoTo !== '' && this.form.docNoFrom !== '') {
        var docnoFr = Number(this.form.docNoFrom)
        var docnoTo = Number(this.form.docNoTo)
        if (!isNaN(docnoTo) && docnoTo < docnoFr) {
          return 'entry|toDocumentNo'
        } else {
          return 'numeric'
        }
      } else {
        return 'required|numeric'
      }
    }
  },
  created() {
    this.tranTypeList = tranTypeList
    this.branchOption = branchOption
    this.doInit()

    this.$validator.extend('toDocumentNo', {
      getMessage(field, args) {
        return 'To Document No. cannot be less than From Document No.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var docNoTo = args[0]
        if (docNoTo) {
          return true
        } else {
          return false
        }
      }
    })
  },
  watch: {
  },
  mixins: [
    MessageMixin
  ]
}

</script>
